<template>
  <footer>
    <div class="py-8 md:py-12">
      <div class="max-w-6xl mx-auto px-4 sm:px-6">
        <!-- Top area: Blocks -->
        <div class="grid md:grid-cols-12 gap-8 lg:gap-20 mb-4 md:mb-8">
          <!-- 1st block -->
          <div class="md:col-span-4 lg:col-span-5">
            <div class="mb-2">
              <!-- Logo -->
              <router-link to="/" class="inline-block" aria-label="Cruip">
                <img class="w-32" :src="require('@/images/takahashi-name-logo.svg')" alt="高橋章友" />
              </router-link>
            </div>
          </div>
        </div>
        <!-- Copyrights note -->
        <div class="text-gray-400 text-sm mr-4">&copy; 2021 Akitomo Takahashi. All rights reserved.</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
}
</script>
